import React, { useContext, useState } from 'react';
import { Modal, Collapse, Button } from 'react-bootstrap';
import { ModalContext } from '../../context/ModalContext.js';
import fhfLogo from '../../images/fhf_logo.png';
import './AboutModal.css';
import filter_logo from '../../images/Filter.png';
import table_img from '../../images/Table-Export.png';
import search_img from '../../images/Search by Geography.png';

const AboutModal = () => {
    const { modals, closeModal } = useContext(ModalContext);
    const [openSection1, setOpenSection1] = useState(false);
    const [openSection2, setOpenSection2] = useState(false);
    const [openSection3, setOpenSection3] = useState(false);

    return (
        <Modal
            show={modals.about}
            onHide={() => closeModal('about')}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>How to use the Housing Policy Finder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="text-left mb-4">
                <img 
                    src={fhfLogo} 
                    alt="Family Housing Fund Logo" 
                    id="fhf_logo"
                    style={{ maxWidth: '200px', height: 'auto' }}
                />
            </div>
            <p>The Twin Cities Housing Policy Finder tracks local housing affordability, preservation, and protection policies throughout the 7-county metro. Use this interactive resource to learn more about the local policy environment.</p>

            <p>If you'd like to find policies about a particular community of interest…
                <Button
                    onClick={() => setOpenSection1(!openSection1)}
                    aria-controls="section1-collapse"
                    aria-expanded={openSection1}
                    variant="link"
                    className="p-0 ms-2"
                >
                    {openSection1 ? '▼' : '▶'}
                </Button>
            </p>
            <Collapse in={openSection1}>
                <div id="section1-collapse" className="mb-3">
                    <img 
                        src={search_img} 
                        alt="Guide to finding policies" 
                        style={{ maxWidth: '65%', height: 'auto' }}
                    />
                </div>
            </Collapse>

            <p>If you'd like a quick way to learn more about specific policy types…
            <Button
                    onClick={() => setOpenSection2(!openSection2)}
                    aria-controls="section2-collapse"
                    aria-expanded={openSection2}
                    variant="link"
                    className="p-0 ms-2"
                >
                    {openSection2 ? '▼' : '▶'}
                </Button>
            </p>
            <Collapse in={openSection2}>
                <div id="section2-collapse" className="mb-3">
                    <img 
                        src={filter_logo} 
                        alt="Guide to finding policies" 
                        style={{ maxWidth: '65%', height: 'auto' }}
                    />
                </div>
            </Collapse>

<p>If you'd like to view the entire housing policy dataset as a table, or export the table…
<Button
                    onClick={() => setOpenSection3(!openSection3)}
                    aria-controls="section3-collapse"
                    aria-expanded={openSection3}
                    variant="link"
                    className="p-0 ms-2"
                >
                    {openSection3 ? '▼' : '▶'}
                </Button>
            </p>
            <Collapse in={openSection3}>
                <div id="section3-collapse" className="mb-3">
                    <img 
                        src={table_img} 
                        alt="Guide to finding policies" 
                        style={{ maxWidth: '65%', height: 'auto' }}
                    />
                </div>
            </Collapse>



            </Modal.Body>
        </Modal>
    );
}

export default AboutModal;